var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ancestryline-modal',{attrs:{"title":"forms.client.title","id":'modal-client-form-'+_vm.id,"close":true,"loading":false},on:{"close":_vm.close}},[_c('ClientForm',{key:_vm.id,attrs:{"show-header":false,"client-id":_vm.clientId,"modal-id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }